<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
</script>
<template>
  <div v-show="layout === 'default'" class="min-height-300 position-absolute w-100 bg-gris" />

  <aside class="overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs" :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start '}
      ${layout === 'landing' ? 'bg-gris shadow-none' : ' '} ${sidebarType}`" id="sidenav-main">
    <div class="sidenav-header text-center pb-4" style="background-color: #f4f3fb">
      <i class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true" id="iconSidenav"></i>

      <router-link class="m-0 text-center" to="/">
        <Logos :text="marca" tamano="medium" />
      </router-link>
    </div>

    <sidenav-list />
  </aside>
</template>
<script>
import Logos from "../../views/components/Logos.vue";
import ClienteService from "@/services/ClienteService";

export default {
  name: "Logo Dashboard",
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      marca: "",
    };
  },
  created() {
    this.initLogo();
  },
  methods: {
    async initLogo() {
      const user = this.user;
      if (user && user.id_cliente) {
        try {
          const response = await ClienteService.getClientesActivos();
          const cliente = response.data.data.find(c => c.id === user.id_cliente);
          if (cliente && cliente.slug) {
            this.marca = cliente.slug;
          }
        } catch (error) {
          console.error("Error al obtener cliente:", error);
        }
      }
    }
  },
  components: {
    Logos,
  },
};
</script>
